import { getApolloClient } from '../../../apollo/apolloClientSingleton'
import { commenceKlarnaOrderMutation } from './commenceKlarnaOrder.mutation.gql'

export const nothingToPayWithAdyen = (checkout) => {
  return checkout ? checkout.options?.amount?.value === 0 : true
}

export const KLARNA_PAYMENT_OPTIONS = {
  PAY_NOW: 'pay_now',
  PAY_LATER: 'pay_later',
  PAY_OVER_TIME: 'pay_over_time'
}

export const replaceAdyenKlarnaOptions = ({ adyenPaymentOptions, klarnaPaymentOptions }) => {
  if (klarnaPaymentOptions.length === 0) {
    return [...adyenPaymentOptions]
  }
  const firstKlarnaIndex = adyenPaymentOptions.findIndex((option) =>
    option.type?.includes('klarna')
  )

  if (firstKlarnaIndex === -1) {
    return [...adyenPaymentOptions, ...klarnaPaymentOptions]
  }

  return [
    ...adyenPaymentOptions.slice(0, firstKlarnaIndex),
    ...klarnaPaymentOptions,
    ...adyenPaymentOptions
      .slice(firstKlarnaIndex)
      .filter((option) => !option.type?.includes('klarna'))
  ]
}

export const commenceKlarnaOrder = async ({ consent, email, sessionId }) => {
  const apolloClient = getApolloClient()

  return apolloClient.mutate({
    mutation: commenceKlarnaOrderMutation,
    variables: { params: { dataUsageConsent: consent, email, sessionId } }
  })
}
